/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomContractFeesDto
 */
export interface CustomContractFeesDto {
    /**
     * Unique identifier of the fee
     * @type {string}
     * @memberof CustomContractFeesDto
     */
    id: string;
    /**
     * Value of the fee
     * @type {number}
     * @memberof CustomContractFeesDto
     */
    value: number;
}

/**
 * Check if a given object implements the CustomContractFeesDto interface.
 */
export function instanceOfCustomContractFeesDto(value: object): value is CustomContractFeesDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function CustomContractFeesDtoFromJSON(json: any): CustomContractFeesDto {
    return CustomContractFeesDtoFromJSONTyped(json, false);
}

export function CustomContractFeesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomContractFeesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'value': json['value'],
    };
}

export function CustomContractFeesDtoToJSON(json: any): CustomContractFeesDto {
    return CustomContractFeesDtoToJSONTyped(json, false);
}

export function CustomContractFeesDtoToJSONTyped(value?: CustomContractFeesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'value': value['value'],
    };
}

